import { z } from 'zod';

export const createClientAdminUserSchema = z.object({
  fullName: z.string().min(1, '氏名は必須です。'),
  email: z
    .string()
    .email('有効なメールアドレスを入力してください。')
    .min(1, 'メールアドレスは必須です。'),
});

export type CreateClientAdminUserFormFieldValues = z.infer<typeof createClientAdminUserSchema>;
